export const NodeController05ABI = [
	{
		inputs: [],
		name: "LNodeController__UnregistredNode",
		type: "error",
	},
	{ inputs: [], name: "NodesFacet_NoNodesFound", type: "error" },
	{
		inputs: [],
		name: "NodesFacet_NotEnoughBalance",
		type: "error",
	},
	{
		inputs: [{ internalType: "address", name: "account", type: "address" }],
		name: "getAllNodes",
		outputs: [
			{
				components: [
					{ internalType: "string", name: "name", type: "string" },
					{
						internalType: "uint256",
						name: "creation",
						type: "uint256",
					},
					{
						internalType: "uint256",
						name: "lastClaimTime",
						type: "uint256",
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256",
					},
					{
						internalType: "uint256",
						name: "rewardPaid",
						type: "uint256",
					},
					{ internalType: "bool", name: "active", type: "bool" },
					{
						internalType: "uint256",
						name: "lastRewardUpdate",
						type: "uint256",
					},
				],
				internalType: "struct Node[]",
				name: "",
				type: "tuple[]",
			},
		],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "address", name: "_account", type: "address" }],
		name: "getAllNodesAmount",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "address", name: "_account", type: "address" }],
		name: "getAllNodesRewards",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
		name: "getNodeRewards",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "address", name: "account", type: "address" }],
		name: "getNodesCount",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256[]", name: "_ids", type: "uint256[]" }],
		name: "getNodesRewards",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [],
		name: "getTotalValueLocked",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [],
		name: "totalNodesCreated",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [],
		name: "ERC721Facet__ApproveCallerNotOwnerOrApproved",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__GlobalIndexOutOfBounds",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__InvalidApprovalToCurrentOwner",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__InvalidBaseURI",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__NonTransferrable",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__OnlyApprovedOrOwner",
		type: "error",
	},
	{
		inputs: [],
		name: "ERC721Facet__OwnerIndexOutOfBounds",
		type: "error",
	},
	{ inputs: [], name: "LDiamond__OnlyOwner", type: "error" },
	{
		inputs: [],
		name: "LERC721__InvalidApproveToCaller",
		type: "error",
	},
	{ inputs: [], name: "LERC721__InvalidToken", type: "error" },
	{
		inputs: [],
		name: "LERC721__InvalidTransferToAddressZero",
		type: "error",
	},
	{ inputs: [], name: "LERC721__SenderIsNotOwner", type: "error" },
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address",
			},
			{
				indexed: true,
				internalType: "address",
				name: "approved",
				type: "address",
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256",
			},
		],
		name: "Approval",
		type: "event",
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address",
			},
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address",
			},
			{
				indexed: false,
				internalType: "bool",
				name: "approved",
				type: "bool",
			},
		],
		name: "ApprovalForAll",
		type: "event",
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address",
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address",
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256",
			},
		],
		name: "Transfer",
		type: "event",
	},
	{
		inputs: [
			{ internalType: "address", name: "_to", type: "address" },
			{ internalType: "uint256", name: "_id", type: "uint256" },
		],
		name: "approve",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [{ internalType: "address", name: "_account", type: "address" }],
		name: "balanceOf",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
		name: "getApproved",
		outputs: [{ internalType: "address", name: "", type: "address" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address",
			},
			{
				internalType: "address",
				name: "_operator",
				type: "address",
			},
		],
		name: "isApprovedForAll",
		outputs: [{ internalType: "bool", name: "", type: "bool" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [],
		name: "name",
		outputs: [{ internalType: "string", name: "", type: "string" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
		name: "ownerOf",
		outputs: [{ internalType: "address", name: "", type: "address" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "address", name: "_from", type: "address" },
			{ internalType: "address", name: "_to", type: "address" },
			{ internalType: "uint256", name: "_id", type: "uint256" },
		],
		name: "safeTransferFrom",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "address", name: "_from", type: "address" },
			{ internalType: "address", name: "_to", type: "address" },
			{ internalType: "uint256", name: "_id", type: "uint256" },
			{ internalType: "bytes", name: "_data", type: "bytes" },
		],
		name: "safeTransferFrom",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_operator",
				type: "address",
			},
			{ internalType: "bool", name: "_approved", type: "bool" },
		],
		name: "setApprovalForAll",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [],
		name: "symbol",
		outputs: [{ internalType: "string", name: "", type: "string" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256", name: "_index", type: "uint256" }],
		name: "tokenByIndex",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_account",
				type: "address",
			},
			{ internalType: "uint256", name: "_index", type: "uint256" },
		],
		name: "tokenOfOwnerByIndex",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256", name: "_id", type: "uint256" }],
		name: "tokenURI",
		outputs: [{ internalType: "string", name: "", type: "string" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [],
		name: "totalSupply",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "address", name: "_from", type: "address" },
			{ internalType: "address", name: "_to", type: "address" },
			{ internalType: "uint256", name: "_id", type: "uint256" },
		],
		name: "transferFrom",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [{ internalType: "string", name: "_baseURI", type: "string" }],
		name: "updateBaseURI",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{ inputs: [], name: "LFees__AVAXTransaferFailed", type: "error" },
	{ inputs: [], name: "LFees__InvalidClaimFee", type: "error" },
	{ inputs: [], name: "LFees__InvalidCompoundFee", type: "error" },
	{ inputs: [], name: "LFees__InvalidDepositFee", type: "error" },
	{
		inputs: [],
		name: "VaporControllerFacet__InvalidAddress",
		type: "error",
	},
	{
		inputs: [],
		name: "VaporControllerFacet__InvalidAmount",
		type: "error",
	},
	{
		inputs: [],
		name: "VaporControllerFacet__MaxAmountReached",
		type: "error",
	},
	{
		inputs: [],
		name: "VaporControllerFacet__NotEnoughBalance",
		type: "error",
	},
	{
		inputs: [],
		name: "VaporControllerFacet__OnlyNodeOwner",
		type: "error",
	},
	{
		inputs: [{ internalType: "uint256[]", name: "_ids", type: "uint256[]" }],
		name: "claim",
		outputs: [],
		stateMutability: "payable",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "tokenIds",
				type: "uint256[]",
			},
		],
		name: "compound",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "string", name: "_name", type: "string" },
			{ internalType: "uint256", name: "_amount", type: "uint256" },
		],
		name: "createNode",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [{ internalType: "uint256[]", name: "_ids", type: "uint256[]" }],
		name: "getClaimTaxQuote",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "uint256", name: "_id", type: "uint256" },
			{ internalType: "uint256", name: "_amount", type: "uint256" },
		],
		name: "increaseNodeAmount",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "uint256", name: "_id", type: "uint256" },
			{ internalType: "string", name: "_name", type: "string" },
		],
		name: "renameNode",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [],
		name: "LERC721__AlreadyMintedToken",
		type: "error",
	},
	{
		inputs: [],
		name: "LERC721__InvalidMintToAddressZero",
		type: "error",
	},
	{
		inputs: [],
		name: "LERC721__TranferToNonERC721Receiver",
		type: "error",
	},
	{ inputs: [], name: "LPausable__PausedFeature", type: "error" },
	{
		inputs: [],
		name: "MigrationFacet__UserHasNoNodesToMigrate",
		type: "error",
	},
	{
		inputs: [],
		name: "MigrationFacet__UserNodesAlreadyMigrated",
		type: "error",
	},
	{
		inputs: [{ internalType: "address", name: "_account", type: "address" }],
		name: "alreadyMigrated",
		outputs: [{ internalType: "bool", name: "", type: "bool" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{ internalType: "uint256", name: "amount", type: "uint256" },
			{
				internalType: "uint256",
				name: "lastClaim",
				type: "uint256",
			},
			{
				internalType: "uint256",
				name: "lastCompound",
				type: "uint256",
			},
		],
		name: "getPendingRewards",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [{ internalType: "address", name: "_account", type: "address" }],
		name: "migrateNodes",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
	{
		inputs: [],
		name: "totalNodesMigrated",
		outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
		stateMutability: "view",
		type: "function",
	},
] as const;

export default NodeController05ABI;
